import React, { Children, cloneElement, ReactElement, ReactNode } from "react";
import { usePinnableItems } from "./usePinnableItems";
import { Box, BoxProps } from "@mui/material";

export interface PinnableProps {
  name: string;
  model: any; // Consider replacing 'any' with a more specific type if possible
  children: ReactElement | ReactElement[];
}

export default function Pinnable({ name, model, children }: PinnableProps) {
  const { pin, setHovered, clearHovered } = usePinnableItems();

  const listeners = {
    onMouseEnter: () => setHovered(name, model),
    onMouseLeave: () => clearHovered(),
    onClick: () => pin(name, model),
  };

  if (children != null && "length" in children) {
    return (
      <Box
        {...listeners}
        sx={{
          "&:hover": {
            cursor: "pointer",
          },
        }}
      >
        {children}
      </Box>
    );
  }

  return cloneElement(Children.only(children), listeners);
}
